import React from "react";
import { Routes, Route } from "react-router";
import Landing from "../pages/Landing";
import Lyra from "../pages/Lyra";
import NotFound from "../pages/NotFound";
import ErrorBoundary from "./ErrorBoundary";
import styles from "./App.module.css";

const App: React.FC = () => {
  return (
    <div className={styles.app}>
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/lyra" element={<Lyra />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </div>
  );
};

App.displayName = "App";

export default App;
